module.exports = __webpack_public_path__ + "static/media/1POLICY29.5d5eae32.jpg";